'use client';
import { HTMLAttributes, useEffect, useRef, useState } from 'react';
import { HtmlViewer } from '@/components/features/HtmlViewer/HtmlViewer';
import { useResizeObserver } from '@/hooks/useResizeObserver';
import s from './OpeningContainer.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  text?: string | null;
  label?: string;
}

const labelHeight = 24;
const labelMarginBottom = 12;
const maxHeightWithFourRows = 136;

export const OpeningContainer = ({ label, text, className }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [fullHeight, setFullHeight] = useState(0);

  useResizeObserver({
    onResize: calcFullHeight,
    onBody: true,
  });

  useEffect(() => {
    if (!contentRef.current) return;

    calcFullHeight();
  }, [contentRef]);

  function calcFullHeight() {
    setFullHeight((contentRef.current?.scrollHeight || 0) + labelHeight + labelMarginBottom);
  }

  const hasHiddenText = contentRef.current && contentRef.current.scrollHeight > maxHeightWithFourRows;

  return (
    <div className={s.container}>
      <div className={s.container__inner} style={{ maxHeight: isOpen ? fullHeight : maxHeightWithFourRows }}>
        <div ref={contentRef}>
          <HtmlViewer label={label} text={text} className={className} isContentBlock />
        </div>
      </div>
      {hasHiddenText && (
        <button
          className={s.container__button}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? 'Скрыть' : 'Показать ещё'}
        </button>
      )}
    </div>
  );
};